/*
PROTECTED PAGE 
*/
import React from "react";
import Support from "../../Components/Support/Support";
import Layout from "../../Components/Layout/Layout";



export default function SupportPage() {
  return (
    <Layout>
    <Support />
    </Layout>
  );
}
